import { Component, input } from '@angular/core';
import { Params, QueryParamsHandling, RouterLink } from '@angular/router';

@Component({
  imports: [RouterLink],
  selector: 'avs-breadcrumb',
  standalone: true,
  styleUrl: './breadcrumb.component.scss',
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent {
  label = input<string>();
  link = input<string | string[]>();
  queryParams = input<Params>();
  queryParamsHandling = input<QueryParamsHandling>();
}
